/* eslint react/jsx-pascal-case: [0, { ignore: 1 }] */

import React from 'react';
import classNames from 'classnames';

// styles
import styles from './PayBtn.module.css';


class PayBtn extends React.PureComponent {

  /******************************************
  * COMPONENT HOOKS
  ******************************************/

  render() {
    const btnClasses = classNames({
      [styles.PayBtn]: true,
      [this.props.className]: !!this.props.className,
    });

    return (
      <button className={btnClasses}
        onClick={this.props.onClick.bind(this)}>
        <img className={styles.Icon} alt="crown" src="/assets/img/crown.svg" />
      </button>
    );
  }
}

export default PayBtn;
